import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import * as actions from "../../store/actions/index";
import { withRouter } from "../../shared/utility";

// Template Components
import DataManagementTemplate from "../../components/templates/DataManagementTemplate";
import MobileCardsTemplate from "../../components/templates/MobileCardsTemplate";

// Other Components
import SlideOver from "../../components/slideOver/SlideOver";
import EmptyModal from "../../components/modals/EmptyModal";
import { CustomerGroupsViewModel } from "../../viewmodels/customerGroups/CustomerGroupsViewModel";

function CustomerGroups(props) {
  const { logout } = props;
  const navigate = useNavigate();
  const {
    emptyModal,
    setEmptyModelOpen,
    getCustomerGroups,
    loading,
    customerGroups,
    setSlideOver,
    slideOver,
  } = CustomerGroupsViewModel(logout);

  var currentPage = 1;
  useEffect(() => {
    getCustomerGroups(null, currentPage);
  }, []);

  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(50);
  const [searchTerm, setSearchTerm] = useState("");

  // Search handler
  const handleSearch = (term) => {
    setSearchTerm(term);
    getCustomerGroups(term || null, currentPage);
  };

  // Pagination handler
  const handlePageChange = (event) => {
    currentPage = event.page + 1;
    setFirst(event.first);
    setRows(event.rows);
    getCustomerGroups(searchTerm || null, currentPage);
  };

  // Row click handler
  const handleRowClick = (group) => {
    navigate(`/customer-groups/${group.id}`);
  };

  // Button configurations
  const headerButtons = [
    {
      label: "Add Group",
      onClick: () => navigate("/customer-groups/new"),
      className: "bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white focus:ring-primary-500"
    }
  ];

  // Column configurations for DataTable
  const columns = [
    {
      field: "name",
      header: "Group Name",
      style: { width: '40%' },
      body: (rowData) => (
        <span className="font-semibold apollo-subheading text-gray-900">
          {rowData.name}
        </span>
      )
    },
    {
      field: "total_in_group",
      header: "Customers in group",
      style: { width: '40%' },
      body: (rowData) => (
        <span className="apollo-body">{rowData.total_in_group}</span>
      )
    },
    {
      header: "Actions",
      style: { width: '20%' },
      body: (rowData) => (
        <Link
          className="inline-flex items-center justify-center px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg shadow-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
          to={`/customer-groups/${rowData.id}`}
        >
          View
        </Link>
      )
    }
  ];

  // Mobile cards component
  const CustomerGroupsMobileCards = ({ data }) => (
    <MobileCardsTemplate
      data={data}
      onCardClick={(group) => navigate(`/customer-groups/${group.id}`)}
      onEdit={(group) => navigate(`/customer-groups/${group.id}`)}
      editRoute="/customer-groups"
      emptyMessage="No customer groups found"
      cardContent={(group) => (
        <div className="flex flex-col space-y-3">
          {/* Header */}
          <div className="flex justify-between items-start">
            <div>
              <h3 className="text-h6 apollo-heading text-primary-600 mb-1">
                {group.name}
              </h3>
              <p className="text-body-2 apollo-subheading">
                {group.total_in_group} customers in group
              </p>
            </div>
          </div>
        </div>
      )}
      actionButtons={(group) => (
        <div className="flex gap-2 pt-2" onClick={(e) => e.stopPropagation()}>
          <Link to={`/customer-groups/${group.id}`} className="flex-1">
            <button
              className="w-full inline-flex items-center justify-center px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg shadow-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
            >
              View
            </button>
          </Link>
        </div>
      )}
    />
  );

  return (
    <div>
      <DataManagementTemplate
        title="Customer Groups"
        description="Manage your customer groups"
        headerButtons={headerButtons}
        columns={columns}
        data={customerGroups.data || []}
        loading={loading}
        pagination={{
          first: first,
          rows: rows,
          total: customerGroups.total || 0,
          template: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
          currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} customer groups"
        }}
        onSearch={handleSearch}
        onPageChange={handlePageChange}
        onRowClick={handleRowClick}
        searchPlaceholder="Search by customer group name"
        MobileCardsComponent={CustomerGroupsMobileCards}
        emptyMessage="No customer groups found"
      />
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CustomerGroups)
);
